export default __webpack_public_path__ + "static/media/item-box-sample1.45af1d5b.png";